module.exports = __webpack_public_path__ + "assets/img/8f510bcbf7aa442f7cb48e795bac7dd4.png";